import React from "react";
import Hotspot from "./Hotspot";
import { useDispatch, useSelector } from "react-redux";
import { setHotspotIndexOfHoverMessageShown } from "../../redux";
import { dragClickListener } from "../../util/browserGeometry";
import {
  getHotspotIndexOfClickMessageShown,
  getHotspotIndexOfHoverMessageShown,
  getCurrentStep,
  getHotspotDisplayState,
  getWidth,
  getHeight,
} from "../../redux/selectors";
import {
  activePointerClassName,
  hotspotDisplayStates,
  steps,
} from "../../util/constants";
import { dragActiveHotspot, selectHotspot } from "../../redux/ui/ui";

export const NormalModeHotspot = React.forwardRef((props, ref) => {
  const { hotspotIndex, coordinates, template, ...rest } = props;

  const dispatch = useDispatch();
  const currentStep = useSelector(getCurrentStep);
  const displayState = useSelector((state) =>
    getHotspotDisplayState(state, { hotspotIndex })
  );

  const hotspotIndexOfClickMessageShown = useSelector(
    getHotspotIndexOfClickMessageShown
  );

  const hotspotIndexOfHoverMessageShown = useSelector(
    getHotspotIndexOfHoverMessageShown
  );
  const className =
    hotspotIndexOfClickMessageShown === hotspotIndex && activePointerClassName;

  const onPointerDown = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (
      [
        steps.preview,
        steps.configureHoverAction,
        steps.configureClickAction,
        steps.configurePointerText,
      ].includes(currentStep)
    ) {
      dispatch(selectHotspot({ hotspotIndex }));
    }
  };

  const width = useSelector(getWidth);
  const height = useSelector(getHeight);
  let { x: x0, y: y0 } = coordinates ?? {};
  x0 = (x0 / 100) * width;
  y0 = (y0 / 100) * height;
  const onDrag = (e, { dx, dy }) => {
    // remember and enclose the initial parameters
    const el = ref.current;
    if (!el) {
      return;
    }
    const x = x0 + dx;
    const y = y0 + dy;
    dispatch(
      dragActiveHotspot({
        hotspotIndex,
        mouseCoordinatesInPercent: {
          x: (100.0 * x) / width,
          y: (100.0 * y) / height,
        },
      })
    );
  };

  const pointerDownHandler = (e) =>
    dragClickListener(e, { onDrag, onPointerDown });

  const onPointerEnter = (e) => {
    if (
      [steps.preview].includes(currentStep) &&
      hotspotIndex !== hotspotIndexOfHoverMessageShown
    ) {
      dispatch(setHotspotIndexOfHoverMessageShown(hotspotIndex));
    }
  };
  const onPointerLeave = (e) => {
    if ([steps.preview].includes(currentStep)) {
      dispatch(setHotspotIndexOfHoverMessageShown(null));
    }
  };

  return (
    displayState === hotspotDisplayStates.normal && (
      <Hotspot
        ref={ref}
        coordinates={coordinates}
        onPointerDown={pointerDownHandler}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
        className={className}
        template={template}
        {...rest}
      />
    )
  );
});
